<template>
  <div>
    <div class="row">
      <div class="col-lg-12 col-md-12 col-12">
        <dl class="row mb-5">
          <dd class="col-sm-12 mb-0 fw-700 text-info">Client information</dd>
          <dd class="col-sm-4 mb-0">New quote id</dd>
          <dd class="col-sm-8 mb-0 fw-700 text-primary">
            {{ otherData.confirmData.id }}
          </dd>
          <dd class="col-sm-4 mb-0">Name</dd>
          <dd class="col-sm-8 mb-0">
            {{ propsData.client }}
          </dd>
          <dd class="col-sm-4 mb-0">Email</dd>
          <dd class="col-sm-8 mb-0">
            {{ propsData.clientEmail }}
          </dd>
          <dd class="col-sm-4 mb-0">Mobile</dd>
          <dd class="col-sm-8 mb-0">
            {{ propsData.clientMobileNumber }}
          </dd>
        </dl>
        <dl class="row">
          <dd class="col-sm-12 mb-0 fw-700 text-info">
            New Dealer information
          </dd>
          <dd class="col-sm-4 mb-0">Name</dd>
          <dd class="col-sm-8 mb-0 fw-700 text-primary">
            {{ otherData.objDealer.name }}
          </dd>
          <dd class="col-sm-4 mb-0">User</dd>
          <dd class="col-sm-8 mb-0">
            {{ otherData.objDealerStaff.name }}
          </dd>
        </dl>
      </div>
    </div>
    <hr />
    <div class="text-right">
      <button
        type="button"
        @click="fnGoEditQuote()"
        class="btn btn-primary btn-sm mr-2"
      >
        <b-spinner small v-if="is_spinActive"></b-spinner>
        Open new quote
      </button>
      <button
        type="button"
        @click="fnSendAssignedQuoteNotification()"
        class="btn btn-primary btn-sm mr-2"
      >
        <b-spinner small v-if="is_spinActiveConfirm"></b-spinner>
        Send email to dealer
      </button>
      <button type="button" class="btn btn-dark btn-sm" @click="hideModal">
        Cancel
      </button>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import * as authService from '../../../services/auth.service'
import * as messageService from '../../../services/message.service'
import * as maturingLeasService from '../../../services/maturingLeas.service'
export default {
  name: 'SectionConfirmNewQuote',
  props: {
    propsData: {
      type: Object,
      required: true
    },
    otherData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      errors: {},
      loginUserObj: {},
      is_spinActive: false,
      is_spinActiveConfirm: false
    }
  },
  computed: {
    ...mapGetters(['getMaturingLeasPaginateData', 'getMaturingLeasPaginate'])
  },
  methods: {
    ...mapActions(['fetchMaturingLeasPaginate']),
    /**
     * Hide modal
     */
    hideModal() {
      this.fetchMaturingLeasPaginate(this.getMaturingLeasPaginate)
      this.$emit('closeModal')
    },

    /**
     * For Edit 7 confirmation quote
     */
    fnGoEditQuote() {
      if (this.loginUserObj.role_id == 1 || this.loginUserObj.role_id == 2) {
        this.$router.push({
          name: 'admin.quoteEdit',
          params: { quoteId: this.otherData.confirmData.id }
        })
      }

      if (this.loginUserObj.role_id == 3) {
        this.$router.push({
          name: 'bdm.quoteEdit',
          params: { quoteId: this.otherData.confirmData.id }
        })
      }
    },
    /**
     * For Create quote
     */
    fnSendAssignedQuoteNotification: async function () {
      try {
        this.is_spinActiveConfirm = true

        const { name: newDealerUser, email: newDealerUserEmail } =
          this.otherData.objDealerStaff

        const response =
          await maturingLeasService.sendAssignedQuoteNotification({
            newQuoteId: this.otherData.confirmData.id,
            newDealerUser: newDealerUser,
            newDealerUserEmail: newDealerUserEmail
          })

        if (response.status === 200) {
          this.is_spinActiveConfirm = false
          messageService.fnSweetAlertSuccessToast(
            'Send notification',
            'Sent successfully'
          )
        }
      } catch (error) {
        switch (error.response.status) {
          case 422:
            this.errors = error.response.data.errors
            break
          case 500:
            messageService.fnSweetAlertErrorToast(
              'Send notification',
              error.response.data.message
            )
            break
          default:
            messageService.fnSweetAlertErrorToast(
              'Send notification',
              'Something wrong'
            )
            break
        }
        this.is_spinActiveConfirm = false
      }
    }
  },
  created() {
    this.loginUserObj = authService.getUserFromToken()
  }
}
</script>
